export function getRoutePrefix() {
  const match = window.location.pathname.match(/[^\/]+/);
  const shopId = match ? match[0] : "";
  return shopId;
}
